import script from "./SimulateChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulateChart.vue?vue&type=script&setup=true&lang=js"

import "./SimulateChart.vue?vue&type=style&index=0&id=a2ffc8fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2ffc8fc"]])

export default __exports__